import React from 'react';
import { StyledStrong } from './strong.style.js';

export const Strong = ({ children, ...rest }) => {
  return <StyledStrong {...rest}>{children}</StyledStrong>;
};

export default Strong;
